import { Smile, Car, ChefHat, Tablet, Moon, Music } from "lucide-react";

const services = [
  { icon: Smile, title: "Daily Companionship", outcome: "Meaningful conversation, brightened days" },
  { icon: Car, title: "Private Transportation & Accompaniment", outcome: "Private transportation for appointments and errands — your companion stays with you the whole way, not just behind the wheel" },
  { icon: ChefHat, title: "Cook-Together Companionship", outcome: "Cooking together, your way, at your pace" },
  { icon: Tablet, title: "Technology Concierge", outcome: "Patient, unhurried, never condescending" },
  { icon: Moon, title: "Overnight Companion Service", outcome: "A trusted presence through the night" },
  { icon: Music, title: "Social & Cultural Accompaniment", outcome: "Outings that matter to them — a concert, a favorite restaurant, a Sunday drive — accompanied with genuine care" },
];

const ServicesOutcome = () => (
  <section className="py-24 md:py-32 bg-background">
    <div className="container">
      <p className="text-xs md:text-sm uppercase tracking-[0.25em] text-warm-ink text-center mb-4 font-medium">Concierge Offerings</p>
      <h2 className="text-3xl md:text-5xl font-heading font-semibold text-center mb-6">In-Home Companion Care Services in Nashville</h2>
      <div className="w-16 h-px bg-warm mx-auto mb-8" />
      <p className="text-foreground/75 text-center mb-16 max-w-2xl mx-auto text-base md:text-lg font-light leading-relaxed">
        Kinship Care Collective offers a range of bespoke non-medical companion and life management services, designed for older adults who deserve genuinely invested, deeply committed support.
      </p>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6 max-w-5xl mx-auto">
        {services.map((s, i) => (
          <div key={i} className="bg-card rounded-lg p-7 border border-border hover:shadow-md transition-shadow">
            <div className="inline-flex items-center justify-center w-11 h-11 rounded-full bg-warm/15 mb-4">
              <s.icon className="h-5 w-5 text-warm" />
            </div>
            <h3 className="font-heading font-semibold text-lg mb-2 leading-snug">{s.title}</h3>
            <p className="text-muted-foreground text-sm font-light italic">{s.outcome}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default ServicesOutcome;
